<template>
    <div class='bg-white px-3 index'>
        <el-form ref="form" :model="sizeForm" label-width="80px">
            <el-form-item label="会员等级" style="margin-bottom: 0px">
                <el-radio-group v-model="sizeForm.vip" size="mini">
                    <el-radio-button label="不限"></el-radio-button>
                    <el-radio-button label="正象银卡"></el-radio-button>
                    <el-radio-button label="正象金卡"></el-radio-button>
                    <el-radio-button label="正象白金卡"></el-radio-button>
                    <el-radio-button label="正象钻石卡"></el-radio-button>
                    <el-radio-button label="正象黑卡"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="访问日期" style="margin-top: -15px; margin-bottom: 0px">
                <el-date-picker v-model="sizeForm.timer" size="mini" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="精确查询" style="margin-top: -15px; margin-bottom: 0px">
                <el-input v-model="sizeForm.input" placeholder="请输入内容" size="mini"
                    style="width: 200px; margin-left: 10px">
                </el-input>
            </el-form-item>
        </el-form>
        <div>
            <el-button type="primary" size="mini" @click="searchEvent">查询</el-button>
        </div>
        <el-table border class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
            :height="heights">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="用户名称" width="100" align="center"></el-table-column>
            <el-table-column prop="id" label="用户ID" width="100" align="center"></el-table-column>
            <el-table-column prop="id" label="用户类别" width="100" align="center"></el-table-column>
            <el-table-column prop="phone" label="电话" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiving_number" label="微信号码" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="访问时间" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="客服" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="280">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="InitiateSession(scope.row)">发起会话</el-button>
                    <el-button type="text" size="mini" @click="chatRecord(scope.row)">聊天记录</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>

        <el-dialog title="聊天记录" :visible.sync="dialogVisible" class="dialogs" center width="40%" top="10px">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" :style="{height:listheight}" style="overflow:auto;">
                <div style="max-width: 500px; overflow: auto">
                    <div v-for="(item, index) in list" :key="index" class="rec_wp">
                        <div class="u-f">
                            <div>
                                <img :src="item.avatar" alt="" width="50" height="50" class="imgs" />
                            </div>
                            <div>
                                <div>{{ item.create_time }}</div>
                                <div>
                                    <span v-if="item.msg_type!='image'">{{ item.send_context }}</span>
                                    <div v-else-if="item.msg_type=='image'">
                                        <el-image style="width: 80px; height: 80px; margin-right: 5px"
                                            :src="item.send_context" :preview-src-list="[item.send_context]">
                                        </el-image>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                sizeForm: {
                    vip: "",
                    timer: "",
                    input: "",
                },
                tableData: [{}],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                heights: null,
                selectUsers: [],
                dialogVisible: false,
                listheight: null,
                list: [],
            };
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {
            this.getHeight()
        },
        methods: {
            getHeight() {
                let that = this
                that.heights = window.innerHeight - 275 + 'px'
                that.listheight = window.innerHeight - 280 + "px";
                window.onresize = () => {
                    that.heights = window.innerHeight - 275 + 'px'
                    that.listheight = window.innerHeight - 280 + "px";
                }
            },
            searchEvent() {
                this.currentPage = 1
                this.search()
            },
            search() {},
            handleSelectionChange(val) {
                this.selectUsers = val
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },


        },
    };
</script>
<style lang="scss" scoped>
    .index {
        padding-top: 10px;
    }
</style>